<template>
  <div id="app">
    <Snackbar v-if="notification" :note="notification" class="snackbar" />
    <router-view v-show="sidebarOn" name="sidebar" class="sidebar" />
    <span v-show="!sidebarOn">
      <button @click="sidebarOn = true"><md-icon>menu</md-icon></button>
    </span>
    <router-view v-if="user" name="main" class="main" />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import Snackbar from '@/components/Snackbar.vue'

export default {
  components: { Snackbar },

  computed: {
    ...mapState({
      user: state => state.account.email,
      notification: state => state.util.notification,
    }),

    sidebarOn: {
      get: function() {
        return this.$store.state.settings.sidebarOn
      },
      set: function(val) {
        this.$store.state.settings.sidebarOn = val
      },
    },
  },

  methods: {
    ...mapActions({
      refresh: 'account/refresh',
    }),
  },

  created() {
    this.refresh()
  },
}
</script>
